module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/high_protein--xxs@2x-f504cddac86ad3914b651aa5069b0bdf.png";